export default __webpack_public_path__ + "static/media/img-4.9ab8ceb2.png";